import DateFilterService from '../../../services/date-filter-service';
import OutcomeConversionService from '../../../services/outcome-conversion-service';

/**
 * Class for bet event
 */
export default class MyBetEventModel {
  /**
   * Class constructor method
   */
  constructor({
    Banker = false,
    CategoryName = '',
    EventCode = 0,
    EventDateFormated = '',
    // EventDateString = null,
    ItemStatusName = '',
    Market = '',
    MatchID = 0,
    MatchTitle = '',
    OriginalOdd = 0,
    SportName = '',
    TournamentName = '',
    Type = '',
    // negotiate
    Event = '',
    Date = '',
    Odd = 0,
  }) {
    const splitEvents = Event.split('->');
    /**
     * @type {boolean}
     */
    this.banker = Banker;
    this.type = Type;
    /**
     * @type {number}
     */
    this.eventCode = EventCode;
    if (EventDateFormated !== '') {
      this.eventDate = DateFilterService.localDate(EventDateFormated, 'date', APP_SETTINGS.formatting.fullDateFormat, '', false);
      this.eventTime = DateFilterService.localDate(EventDateFormated, 'time', '', APP_SETTINGS.formatting.fullTimeFormat, false);
    } else {
      this.eventDate = DateFilterService.localDate(Date, 'date', APP_SETTINGS.formatting.fullDateFormat, '', true);
      this.eventTime = DateFilterService.localDate(Date, 'time', '', APP_SETTINGS.formatting.fullTimeFormat, true);
    }
    /**
     * @type {string}
     */
    this.eventDateString = DateFilterService.localDate(
      Date,
      'datetime',
      APP_SETTINGS.formatting.shortDateFormat,
      APP_SETTINGS.formatting.fullTimeFormat,
      false,
    );
    /**
     * @type {string}
     */
    this.dateString = Date;
    /**
     * @type {string}
     */
    this.itemStatusName = ItemStatusName;
    /**
     * @type {string}
     */
    this.market = Market;
    this.oddTypeName = Market.split(':').shift();
    /**
     * @type {string}
     */
    this.outcomeName = Market.split(':').pop();
    /**
     * @type {number}
     */
    this.matchID = MatchID;
    /**
     * @type {string}
     */
    this.matchTitle = MatchTitle !== '' ? MatchTitle : splitEvents[3];
    /**
     * @type {number}
     */
    if (OriginalOdd !== 0) {
      this.odd = OutcomeConversionService.outcomeConverter(OriginalOdd);
    } else {
      this.odd = OutcomeConversionService.outcomeConverter(Odd);
    }
    /**
     * @type {string}
     */
    this.sportName = SportName || splitEvents[0];
    /**
     * @type {string}
     */
    this.categoryName = CategoryName || splitEvents[1];
    /**
     * @type {number}
     */
    this.tournamentName = TournamentName || splitEvents[2];
  }
}
